import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import portalAxios from "../portalAxios";
import { CancellationPreviewResponse } from "../contracts/CancellationPreviewResponse";

/** One dated occurrence the target member (self or ward) holds a place on. */
export interface PortalCancellationTarget {
  memberId: string;
  bookingId: string;
  date: string; // YYYY-MM-DD
}

const urlOf = ({ memberId, bookingId, date }: PortalCancellationTarget) =>
  `/portal/members/${memberId}/bookings/${bookingId}/${date}`;

/** What cancelling would cost under the Session's cancellation policy — shown before confirming. */
export const previewOccurrenceCancellation = createAsyncThunk<
  CancellationPreviewResponse,
  PortalCancellationTarget,
  { rejectValue: ApiErrorResponse }
>("portal/previewCancellation", async (target, { rejectWithValue }) => {
  try {
    const response = await portalAxios.get<CancellationPreviewResponse>(`${urlOf(target)}/cancellation-preview`);
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

/** Cancels the target's place on one occurrence; resolves with the applied outcome. */
export const cancelPortalOccurrence = createAsyncThunk<
  CancellationPreviewResponse,
  PortalCancellationTarget,
  { rejectValue: ApiErrorResponse }
>("portal/cancelOccurrence", async (target, { rejectWithValue }) => {
  try {
    const response = await portalAxios.post<CancellationPreviewResponse>(`${urlOf(target)}/cancel`);
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});
